import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moveToDoneLabel: {
		id: 'software.main.board-container.board.swimlane-move-to-done.move-to-done-label',
		defaultMessage: 'Move to Done',
		description: 'Button to move a parent issue to done when all its subtasks are done',
	},
});
